'use client';
import styled, { css } from 'styled-components';
import { Description, StyledImage } from '@web/atoms/ImageCard/styles';

export const Wrapper = styled.div``;

export const StyledForm = styled.form`
  background: ${props => props.theme.colors.background.base};
  width: 100vw;
  padding-bottom: ${props => props.theme.spacing(25)};

  @media ${props => props.theme.tabletL} {
    display: flex;
    padding-bottom: ${props => props.theme.spacing(0)};
    min-height: 100vh;
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;

  @media ${props => props.theme.tabletL} {
    display: flex;
    position: fixed;
    left: 0;
    z-index: 1;
    height: 100vh;
    width: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const MobileImageContainer = styled.div`
  overflow: hidden;
  border-radius: 24px;
  aspect-ratio: 345/162;
  position: relative;
  img {
    transform: translateY(-15px);
  }

  @media ${props => props.theme.tabletL} {
    display: none;
  }
`;

export const DesktopPillContainer = styled.div`
  display: none;
  flex-shrink: 0;

  @media ${props => props.theme.tabletL} {
    display: block;
  }
`;

export const MobilePillContainer = styled.div`
  ${props =>
    props.$withinImage
      ? css`
          display: flex;
          position: absolute;
          top: 0;
          right: 0;
          transform: translate(-50%, 50%);
          z-index: 1;
        `
      : css`
          display: block;

          @media ${props.theme.tabletL} {
            display: none;
          }
        `}
`;

export const FormContainer = styled.div`
  padding: ${props => props.theme.spacing(6, 5, 0)};
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: ${props => (props.$maxWidth ? `${props.$maxWidth}px` : 'none')};
  margin: auto;
  gap: ${props => props.theme.spacing(3)};

  ${StyledImage} {
    min-height: 85px;
    min-width: 85px;

    img {
      height: 64px;
      width: 64px;
    }
  }

  ${({ $longCards }) =>
    $longCards &&
    css`
      ${Description} {
        min-height: unset;
      }
    `}

  @media ${props => props.theme.tabletL} {
    gap: ${props => props.theme.spacing(3)};
    padding: ${props => props.theme.spacing(4, 0)};
    justify-content: center;
    position: fixed;
    right: 0;
    z-index: 1;
    width: 50%;
    height: 100vh;
    overflow: hidden;
    background-color: ${props => props.theme.colors.background.base};
  }
`;

export const Heading = styled.h2`
  ${({ theme }) => theme.typography.heading2};
  color: ${props => props.theme.colors.text.primary};
  text-align: center;
  flex-shrink: 0;

  @media ${props => props.theme.tablet} {
    ${({ theme }) => theme.typography.heading3};
  }
`;

export const Subheading = styled.p`
  ${props => props.theme.typography.body};
  color: #37332d;
  text-align: center;
  flex-shrink: 0;
  margin-bottom: ${props => props.theme.spacing(2)};
  @media ${props => props.theme.tabletL} {
    width: 80%;
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: 100%;
  fieldset {
    padding: 0;
  }

  @media ${props => props.theme.tabletL} {
    flex: 0 1 auto;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    justify-content: safe center;
    padding-top: ${props => props.theme.spacing(1)};
    padding-bottom: ${props => props.theme.spacing(4)};
    margin-bottom: ${props => props.theme.spacing(40)};
  }
`;

export const ButtonContainer = styled.div`
  z-index: 101;
  display: flex;
  position: fixed;
  top: 17px;
  left: 12px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: auto;
  button {
    border: none;
  }
  @media ${props => props.theme.tabletL} {
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;
